<script>
  import Home from 'src/pc/pages/Home'
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  import Adsense from '../components/Adsense'
  export default {
    extends: Home,
    components: {
      PageLayout,
      DisplayContainer,
      PostContainer,
      DropDown,
      Adsense
    },
    computed: {
      getAccess () {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .bg-gray {
    background: #f5f5f5;
  }
  .home_con .ad_wrap a {
    padding: 20px 0;
  }
  .ad_wrap.mid {
    margin: 0;
    padding: 20px 0;
  }
  .ad_wrap.mid.mid-01 {
    padding: 0;
  }
  .ad_wrap.mid .inner {
    margin: 0;
  }
  .ad_wrap.mid .inner img {
    width: 250px !important;
    height: 250px !important;
  }
  .home_con .cur_content {
    padding: 0;
    box-sizing: border-box;
  }
  .home_con .cur_content .con_wrap {
    width: 100%;
  }
  .home_con .cur_content .con_wrap .con_top {
    display: block;
  }
  .home_con .cur_content .con_wrap .title {
    padding: 15px 0;
    border-top: 1px solid #000;
  }
  .home_con .cur_content .con_wrap .title .subj {
		font-size: 20px;
		line-height: 1.6em;
  }
  .home_con .cur_content .con_wrap .title .subj:before {
		width: 28px;
    height: 30px;
    margin-right: 8px;
  }
  .home_con .cur_content .con_wrap .title .subj i {
		float: unset;
  }
  .home_con .cur_content .con_wrap .title .more {
		font-size: 12px;
    font-weight: 600;
    padding: 6px 12px;
  }
  .home_con .cur_content .con_wrap .con_top {
    margin-top: 15px;
  }
  .home_con .cur_content .con_wrap .con_top .ad_wrap a {
    padding: 40px 0;
  }
  .home_con .cur_content .con_wrap .con_top .sect_01 {
    padding: 0 15px 30px 15px;
    margin: 0;
    border: 0;
    min-height: unset;
    display: block;
    width: 100%;
  }
  .home_con .cur_content .con_wrap .con_top .sect_01 .display-container {
    width: 100%;
  }
  .home_con .cur_content .con_wrap .con_top .sect_01 .display-container .img {
    height: 70vw;
  }
  .home_con .cur_content .con_wrap .con_top .sect_01 .display-container .category {
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 0 0 1.0em 0;
  }
  .home_con .cur_content .con_wrap .con_top .sect_01 .display-container .subj {
    font-size: 19px;
  }
  .home_con .cur_content .con_wrap .con_top .sect_01 .display-container .txt1 {
    font-size: 14px;
    margin-top: 8px;
  }
  .home_con .cur_content .con_wrap .con_top .sect_02 {
    width: 100%;
    background: #fff;
    padding: 30px 15px;
    margin: 0;
  }
  .home_con .cur_content .con_wrap .con_top .sect_02 .display-container:last-child .wrap.s_con {
    border-bottom: 0;
  }
  .home_con .cur_content .con_wrap .con_top .sect_02 .display-container .wrap.s_con {
    padding: 15px 0 15px 0;
    min-height: 110px !important;
  }
	.home_con .cur_content .con_wrap .con_top .sect_02 .display-container .img {
    float: right;
    width: 100px;
    height: 80px;
		margin: 0 0 5px 15px;
  }
  .home_con .cur_content .con_wrap .con_top .sect_02 .display-container .subj {
    font-size: 16.5px;
  }
	.home_con .cur_content .con_wrap .con_top .sect_02 .display-container .txt1 {
    font-size: 14px;
    line-height: 1.6em;
		word-break: normal;
		max-height: 4.6em;
    -webkit-line-clamp: 3;
  }
  .home_con .cur_content .con_wrap .con_top .sect_02 .display-container .category {
    margin-top: 12px;
    font-weight: 500;
  }
  .home_con .cur_content .con_wrap .con_top .sect_03 {
    width: 100%;
    background: #000;
    padding: 30px 15px;
    margin: 0;
  }
  .home_con .cur_content .con_wrap .con_top .sect_03 .display-container .img {
    height: 60vw;
  }
  .home_con .cur_content .con_wrap .con_top .sect_03 .display-container .category {
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 0 0 1.0em 0;
  }
  .home_con .cur_content .con_wrap .con_top .sect_03 .display-container .subj {
    font-size: 17.5px;
    font-weight: 500;
    color: #fff;
  }
	.home_con .cur_content.market_main .con_wrap {
		padding: 0 15px;
  }
	.home_con .cur_content .con_wrap .scroller {
		width: 100vw;
    height: auto;
		padding: 0 15px;
		margin-left: -15px;
	}
	.home_con .cur_content .con_wrap .list_market .ctnr {
		width: calc((100vw - 36px) / 3);
		height: calc((100vw - 36px) / 3);
		margin-right: 3px;
    margin-bottom: 3px;
	}
	.home_con .cur_content .con_wrap .list_market .ctnr:nth-child(5n) {
		margin-right: 3px;
	}
	.home_con .cur_content .con_wrap .list_market .ctnr:nth-child(3n) {
		margin-right: 0;
	}
	.home_con .cur_content .con_wrap .con_issue .sect_01 {
    width: 100vw;
		margin-right: 0;
    padding: 0 15px;
  }
  .home_con .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con {
		height: unset;
    padding: 0 120px 20px 0;
		text-align: right;
		position: relative;
		border-bottom: 1px solid #e5e5e5;
		min-height: 120px;
  }
  .home_con .cur_content .con_wrap .con_issue .sect_01 .display-container:last-child .wrap.l_con {
		border-bottom: 0;
		padding-bottom: 0;
		margin-bottom: 0;
  }
  .home_con .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con .img {
    position: absolute;
    top: 0;
		left: unset;
    right: 0;
    width: 100px;
    height: 100px;
  }
  .home_con .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con .subj {
    font-size: 16.5px;
    margin-bottom: 10px;
    -webkit-line-clamp: 4;
    max-height: 5.4em;
  }
  .home_con .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con .txt1 {
    font-size: 13px;
    line-height: 1.6em;
    display: none;
  }
  .home_con .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con .category {
		font-size: 12px;
    margin-top: 12px;
    font-weight: 500;
  }
  .home_con .cur_content .con_wrap .con_issue .sect_02 {
    width: 100vw;
		padding: 0 15px;
  }
	.home_con .cur_content .con_wrap .con_issue .sect_02 .ctnr .cont {
    width: 79%;
		padding-left: 6.5%;
  }
	.home_con .cur_content .con_wrap .con_issue .sect_02 .ctnr .cont h5 {
		width: 71%;
    font-size: 16px;
		line-height: 1.15em;
  }
	.home_con .cur_content .con_wrap .con_issue .sect_02 .ctnr .cont h6 {
    font-size: 13px;
  }
	.home_con .cur_content .con_wrap .con_issue .sect_02 .ctnr .cont p {
    font-size: 13px;
		color: rgba(0,0,0,0.5);
  }
	.home_con .cur_content .con_wrap .con_issue .sect_02 .ctnr .date b {
    font-size: 20px;
  }
	.home_con .cur_content.ranking .con_wrap  {
    padding: 0 20px;
  }
	.home_con .cur_content .con_wrap .con_rank {
		width: 100vw;
    padding: 0 20px;
    margin-left: -20px;
		overflow-x: auto;
    white-space: nowrap;
    transition: 0.5s;
    scroll-behavior: smooth;
	}
	.home_con .cur_content .con_wrap .con_rank ul {
		
	}
	.home_con .cur_content .con_wrap .con_rank ul li {
		width: 82vw;
		margin-right: 10px;
	}
	.home_con .cur_content .con_wrap .con_rank ul li:last-child {
		margin-right: 20px;
	}
	.home_con .cur_content .con_wrap .con_rank .container {
		width: 100%;
		margin-left: 0;
		margin-bottom: 0;
	}
	.home_con .cur_content .con_wrap .con_rank .container h3 {
		margin: 0;
		line-height: 1.1em;
	}
	.home_con .cur_content .con_wrap .con_rank .container h3 i {
		font-size: 17px;
	}
	.home_con .cur_content .con_wrap .con_rank .container .ranktable {
		min-width: unset;
		overflow-x: hidden;
	}
	.home_con .cur_content .con_wrap .con_rank .container .ranktable th {
		background: #ebebeb;
	}
	.home_con .cur_content .con_wrap .con_rank .container .ranktable th:last-child,
	.home_con .cur_content .con_wrap .con_rank .container .ranktable td:last-child {
		padding-right: 10px;
	}	
	.home_con .cur_content .con_wrap .con_rank .container .ranktable th:nth-child(1),
	.home_con .cur_content .con_wrap .con_rank .container .ranktable td:nth-child(1) {
		width: unset;
	}
	.home_con .cur_content .con_wrap .con_rank .container .ranktable th:nth-child(2),
	.home_con .cur_content .con_wrap .con_rank .container .ranktable td:nth-child(2) {
		width: unset;
	}
	.home_con .cur_content .con_wrap .con_rank .container .ranktable th:nth-child(3),
	.home_con .cur_content .con_wrap .con_rank .container .ranktable td:nth-child(3) {
		width: unset;
	}
  .home_con .cur_content .con_wrap .scr_outer {
		overflow-x: scroll;
    width: 100vw;
    padding: 0;
    margin-left: -20px;
		text-align: left;
    white-space: nowrap;
	}
	.home_con .cur_content .con_wrap .scr_outer .scr_inner {
    padding-left: 20px;
	}
	.home_con .cur_content .con_wrap .con_mid_01 {
    padding: 0 15px;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_01 {
    width: 100%;
		margin: 0 0 20px 0;
		padding: 0;
		border: 0;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_01 .display-container .img {
		width: 100%;
    height: 70vw;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_01 .display-container .subj {
		font-size: 19px;
    font-weight: 600;
		margin-top: 10px;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_01 .display-container .txt1 {
		font-size: 14px;
    margin-top: 8px;
		max-height: 3.0em;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_01 .display-container .category {
		font-size: 12px;
		margin-top: 12px;
    font-weight: 500;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_02 {
		width: 100%;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_02 .display-container {
		width: calc((100% - 10px) / 2);
		margin-right: 10px;
		margin-bottom: 20px;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_02 .display-container:nth-child(n+3) {
		margin-bottom: 0;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_02 .display-container .img {
		height: 33vw;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_02 .display-container .subj {
		font-size: 15px;
		margin-top: 10px;
	}
	.home_con .cur_content .con_wrap .con_mid_01 .sect_02 .display-container .category {
		font-size: 12px;
		margin-top: 12px;
    font-weight: 400;
	}
  .home_con .cur_content .con_wrap .con_btm {
    padding: 0 15px;
    border-top: 0;
  }
  .home_con .cur_content .con_wrap .con_btm .title {
    padding: 15px 0;
    border-top: 1px solid #000;
    /* margin: 50px 0 0; */
  }
  .home_con .cur_content .con_wrap .con_btm .title a {
    font-size: 20px;
    line-height: 1.6em;
  }
  .home_con .cur_content .con_wrap .con_btm .title a:before {
    width: 28px;
    height: 30px;
    margin-right: 8px;
  }
  .home_con .cur_content .con_wrap .con_btm .title a:after {
    width: 14px;
    height: 12px;
    margin-left: 10px;
    margin-top: 11px;
  }

  .home_con .cur_content .con_wrap .con_btm .lst li {
    display: inline-block;
    width: 100%;
    padding: 15px 120px 15px 0;
    min-height: 110px;
    margin-bottom: 0;
    border-bottom: 1px solid #e5e5e5;
    border-right: 0;
    position: relative;
  }
  .home_con .cur_content .con_wrap .con_btm .lst li:nth-child(4n+1),
  .home_con .cur_content .con_wrap .con_btm .lst li:nth-child(4n+4) {
    width: 100%;
    padding: 15px 120px 15px 0;
  }
  .home_con .cur_content .con_wrap .con_btm .lst li a {
    display: flex;
    flex-direction: column;
  }
  .home_con .cur_content .con_wrap .con_btm .lst li .img {
    position: absolute;
    right: 0;
    width: 100px;
    height: 80px;
  }
  .home_con .cur_content .con_wrap .con_btm .lst li .category {
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    text-transform: uppercase;
    order: 2;
  }
  .home_con .cur_content .con_wrap .con_btm .lst li .subj {
    font-size: 15px;
    font-weight: 600;
    margin-top: 0;
    max-height: 4.0em;
    -webkit-line-clamp: 3;
    order: 1;
  }

  .m-hide {
    display: none;
  }
  .p-hide {
    display: block;
  }
</style>
